import "core-js/modules/es.object.to-string.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "container"
  }, [_c("div", {
    staticClass: "top-wrap"
  }), _c("div", {
    staticClass: "titleBar"
  }, [_c("div", {
    staticClass: "img-wrap",
    on: {
      click: _vm.back
    }
  }, [_c("img", {
    attrs: {
      src: require("../../assets/images/arrow.png"),
      alt: ""
    }
  })]), _c("div", {
    staticClass: "center"
  }, [_vm._v(_vm._s(_vm.title))]), _c("div", {
    staticClass: "img-wrap"
  })]), _c("div", {
    staticClass: "content"
  }, [_vm.title != "Dynamic" ? _c("div", _vm._l(_vm.list, function (item) {
    return _c("div", {
      key: item.id,
      staticClass: "item",
      on: {
        click: function click($event) {
          return _vm.toDetail(item.threadId, item.threadCategoryId);
        }
      }
    }, [_c("div", {
      staticClass: "left"
    }, [_c("img", {
      attrs: {
        src: item.threadUserAvatar,
        alt: ""
      }
    }), _c("div", {
      staticClass: "wrap"
    }, [_c("div", [_c("div", {
      staticClass: "nickname"
    }, [_vm._v(_vm._s(item.threadUserNickname))]), _c("div", {
      staticClass: "time"
    }, [_vm._v(_vm._s(item.createdAt))])]), _c("span", {
      staticClass: "txt",
      domProps: {
        innerHTML: _vm._s(item.postContent)
      }
    })])]), _c("img", {
      staticClass: "img",
      attrs: {
        src: require("../../assets/images/A1.png"),
        alt: ""
      }
    })]);
  }), 0) : _c("div", _vm._l(_vm.list, function (item) {
    return _c("div", {
      key: item.id,
      staticClass: "item",
      on: {
        click: function click($event) {
          return _vm.toDetail(item.threadId, item.categoryName);
        }
      }
    }, [_c("div", {
      staticClass: "left"
    }, [item.user.avatar ? _c("img", {
      staticClass: "img",
      attrs: {
        src: item.user.avatar,
        alt: ""
      }
    }) : _c("img", {
      staticClass: "img",
      attrs: {
        src: require("../../assets/images/icon_avatar.png"),
        alt: ""
      }
    }), _c("div", {
      staticClass: "wrap"
    }, [_c("div", [_c("div", {
      staticClass: "nickname"
    }, [_vm._v(_vm._s(item.user.nickname))]), _c("div", {
      staticClass: "time"
    }, [_vm._v(_vm._s(item.createdAt))])]), item.title ? _c("span", {
      staticClass: "txt"
    }, [_vm._v(_vm._s(item.title))]) : _c("span", {
      staticClass: "txt",
      domProps: {
        innerHTML: _vm._s(item.content.text)
      }
    })])]), Object.prototype.toString.call(item["content"]["indexes"]) == "[object Object]" && item["content"]["indexes"]["101"]["body"].length > 0 ? _c("van-image", {
      attrs: {
        fit: "cover",
        src: item["content"]["indexes"]["101"]["body"][0].thumbUrl
      }
    }) : _vm._e(), Object.prototype.toString.call(item["content"]["indexes"]) == "[object Object]" && item["content"]["indexes"]["101"]["body"].length > 0 && item["content"]["indexes"]["101"]["body"][0].type == 2 ? _c("video", {
      attrs: {
        controls: "",
        src: item["content"]["indexes"]["101"]["body"][0].thumbUrl
      }
    }) : _vm._e()], 1);
  }), 0)])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };